import React from 'react';
import { Button } from 'antd';
import ResumeEditorForm from '../components/ResumeEditorForm';
import ResumeInfoGrid from '../components/ResumeInfoGrid';
import { getPropertyName } from '../configs/sectionConfig';

const IntentionsView = ({
  section,
  items,
  setItems,
  editingIndex,
  adding,
  options,
  applicantId,
  formRef,
  setCertificateFile,
  setWorksFile,
  onTrigger,
  onCancel,
  onAdd,
  onAfterEdit,
  maxCount = 5,
}) => {
  const list = items;

  /**
   * 把单条意图派生为展示数据. 现在 JOBTYPE/DISTRICT 都是对象, 实时取 .name.
   * 用 ? 可选链防御: 后端如果某条数据字段缺失(脏数据), 不会崩.
   */
  const buildDisplayData = (item) => ({
    ...item,
    PROPERTY_CN: getPropertyName(item.PROPERTY),
    JOBTYPE_NAME: item.JOBTYPE && item.JOBTYPE.name,
    DISTRICT_NAME: item.DISTRICT && item.DISTRICT.name,
    SALARY: item.SALFROM || item.SALTO ? `${item.SALFROM || 0}-${item.SALTO || 0}元` : '—',
  });

  // 编辑某一条
  if (typeof editingIndex === 'number') {
    const item = list[editingIndex];
    // form 字段的初始值: JOBTYPE/DISTRICT 直接把对象的 .name 字符串给 inputBlur,
    // 避免 antd Input 对对象调 toString() 出现 [object Object]
    const initialValues = {
      ...item,
      JOBTYPE: item.JOBTYPE && item.JOBTYPE.name,
      DISTRICT: item.DISTRICT && item.DISTRICT.name,
    };
    return (
      <>
        {list.slice(0, editingIndex).map((prev, idx) => (
          <div key={prev._key || prev.id || idx} className="resume-new-record">
            <div className="resume-new-record-content">
              <ResumeInfoGrid
                fields={[
                  { label: '期望岗位', props: 'JOBTYPE_NAME' },
                  { label: '岗位性质', props: 'PROPERTY_CN' },
                  { label: '期望城市', props: 'DISTRICT_NAME' },
                  { label: '期望月薪', props: 'SALARY' },
                ]}
                data={buildDisplayData(prev)}
              />
            </div>
          </div>
        ))}
        <ResumeEditorForm
          ref={formRef}
          section={section}
          initialValues={initialValues}
          options={options}
          applicantId={applicantId}
          certificateFile={undefined}
          setCertificateFile={setCertificateFile}
          worksFile={[]}
          setWorksFile={setWorksFile}
          onTrigger={(field) => onTrigger(field, editingIndex)}
          onSubmit={async (values) => {

          console.log(list[editingIndex],'list[editingIndex]');
          
            const updatedItem = {
              ...list[editingIndex],
              ...values,
              // 关键: 对象形态直接保留 (form 字段是字符串, 用 item 里原对象覆盖回去)
              JOBTYPE: list[editingIndex].JOBTYPE,
              DISTRICT: list[editingIndex].DISTRICT,
            };

            // 同步就地更新本地 state,UI 立刻有反馈
            const newItems = [...list];
            newItems[editingIndex] = updatedItem;
            setItems(newItems);

            // 关键: 一定要先 await onAfterEdit 再 onCancel
            // (onCancel 会触发 setState 让 editingIndex 变 undefined, 导致 IntentionsView
            //  下次渲染走不到 onAfterEdit 链路. 即便这次 closure 仍能拿到 onAfterEdit,
            //  也得避免 setState 期间 onAfterEdit 内的 this.props 读到不一致的值)
            if (onAfterEdit) {
              await onAfterEdit({
                item: updatedItem,
                isNew: false,
              });
            }
            onCancel();
          }}
          onCancel={onCancel}
        />
        {list.slice(editingIndex + 1).map((next, idx) => {
          const realIndex = editingIndex + 1 + idx;
          return (
            <div key={next._key || next.id || realIndex} className="resume-new-record">
              <div className="resume-new-record-content">
                <ResumeInfoGrid
                  fields={[
                    { label: '期望岗位', props: 'JOBTYPE_NAME' },
                    { label: '岗位性质', props: 'PROPERTY_CN' },
                    { label: '期望城市', props: 'DISTRICT_NAME' },
                    { label: '期望月薪', props: 'SALARY' },
                  ]}
                  data={buildDisplayData(next)}
                />
              </div>
            </div>
          );
        })}
      </>
    );
  }

  // 添加模式
  if (adding) {
    return (
      <>
        {list.map((item, idx) => (
          <div key={item._key || item.id || idx} className="resume-new-record">
            <div className="resume-new-record-content">
              <ResumeInfoGrid
                fields={[
                  { label: '期望岗位', props: 'JOBTYPE_NAME' },
                  { label: '岗位性质', props: 'PROPERTY_CN' },
                  { label: '期望城市', props: 'DISTRICT_NAME' },
                  { label: '期望月薪', props: 'SALARY' },
                ]}
                data={buildDisplayData(item)}
              />
            </div>
          </div>
        ))}
        <ResumeEditorForm
          ref={formRef}
          section={section}
          initialValues={{}}
          options={options}
          applicantId={applicantId}
          certificateFile={undefined}
          setCertificateFile={setCertificateFile}
          worksFile={[]}
          setWorksFile={setWorksFile}
          onTrigger={(field) => onTrigger(field, list.length)}
          onSubmit={async (values) => {
          
            const lastItem = list[list.length - 1];
            const draftItem = (lastItem && !lastItem.id) ? lastItem : {};
            const empty = ['PROPERTY', 'SALFROM', 'SALTO'].every((key) => {
              const v = values[key];
              if (v === undefined || v === null || v === '') return true;
              if (typeof v === 'number' && v === 0) return true;
              return false;
            }) && !draftItem.JOBTYPE && !draftItem.DISTRICT;
            if (empty) {
              onCancel();
              return;
            }

            const newItem = {
              ...values,
              JOBTYPE: draftItem.JOBTYPE,
              DISTRICT: draftItem.DISTRICT,
              _key: `new-${Date.now()}`,
            };

           
            // 同步把新条目加入本地 state
            setItems((prev) => [...prev, newItem]);

            // 同编辑模式: 先 await onAfterEdit 再 onCancel, 避免 setState 抖动.
            if (onAfterEdit) {
              await onAfterEdit({
                item: newItem,
                isNew: true,
              });
            }
            onCancel();
          }}
          onCancel={onCancel}
        />
      </>
    );
  }

  // 展示态
  return (
    <div className="resume-new-intention-list">
      {list.map((item, idx) => (
        <div key={item._key || item.id || idx} className="resume-new-record">
          <div className="resume-new-record-content">
            <ResumeInfoGrid
              fields={[
                { label: '期望岗位', props: 'JOBTYPE_NAME' },
                { label: '岗位性质', props: 'PROPERTY_CN' },
                { label: '期望城市', props: 'DISTRICT_NAME' },
                { label: '期望月薪', props: 'SALARY' },
              ]}
              data={buildDisplayData(item)}
            />
          </div>
          <div className="resume-new-record-actions">
            <Button type="link" onClick={() => onAdd('edit', idx)}>编辑</Button>
            <Button type="link" danger onClick={() => onAdd('remove', idx)}>删除</Button>
          </div>
        </div>
      ))}
      {list.length < maxCount ? (
        <div className="resume-new-record-add">
          <Button type="dashed" onClick={() => onAdd('add')}>
            + 添加求职意向 ({list.length}/{maxCount})
          </Button>
        </div>
      ) : null}
      {list.length === 0 ? (
        <div className="resume-new-empty">暂无求职意向,点击添加完善信息</div>
      ) : null}
    </div>
  );
};

export default IntentionsView;
